/* Light YouTube Embeds by @labnol */
/* Web: http://labnol.org/?p=27941 */
export function initYT(){
    var div, n,
    v = document.getElementsByClassName("youtube-player");
    for (n = 0; n < v.length; n++) {
        div = document.createElement("div");
        div.setAttribute("data-id", v[n].dataset.id);
        div.innerHTML = labnolThumb(v[n].dataset.id);
        div.onclick = labnolIframe;
        v[n].appendChild(div);
    }
}

function labnolThumb(id) {
    let src_image = '';
    if( window.outerWidth <= 650){
        console.log('Thumbnail mobile');
        src_image = 'https://i.ytimg.com/vi/ID/hqdefault.jpg'
    }else{
        src_image = 'https://i.ytimg.com/vi/ID/maxresdefault.jpg'
    }
    var thumb = `<img src="${src_image}">`,
        play = '<div class="play"></div>';
    return thumb.replace("ID", id) + play;
}

function labnolIframe() {
        var iframe = document.createElement("iframe");
        var embed = "https://www.youtube.com/embed/ID?autoplay=11&enablejsapi=1";
        iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "1");
        this.parentNode.replaceChild(iframe, this);
}